<template>
  <div class="placeholder">
    <AppContainer size="sm">
      <AppHeading :display="1" :level="1">Casey Jacobson</AppHeading>
      <AppHeading :display="4" :level="2">Front-End Engineer</AppHeading>
      <div class="icons">
        <a href="https://github.com/casey6">
          <GithubIcon class="github" />
        </a>
        <a href="mailto:casey@caseyjacobson.com">
          <MailIcon class="mail" />
        </a>
        <a href="https://twitter.com/_caseyjacobson">
          <TwitterIcon class="twitter" />
        </a>
      </div>
    </AppContainer>
  </div>
</template>

<script>
import AppContainer from '~/components/AppContainer';
import AppHeading from '~/components/AppHeading';
import { GithubIcon, MailIcon, TwitterIcon } from 'vue-bytesize-icons';

export default {
  components: { AppContainer, AppHeading, GithubIcon, MailIcon, TwitterIcon },
  metaInfo: {
    titleTemplate: 'Casey Jacobson'
  }
};
</script>

<style lang="scss" src="~/assets/styles/app.scss"></style>

<style>
html,
body {
  height: 100%;
}
</style>

<style lang="scss" scoped>
.placeholder {
  align-items: center;
  border-top: 0.25rem solid rgba(color('primary'), 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  height: 100%;

  img {
    height: 10rem;
    width: 10rem;
  }

  h1 {
    color: color('dark');
    margin-bottom: 0.5rem;
  }

  h2 {
    color: color('primary');
    margin-bottom: 1rem;
  }

  .icons {
    align-items: center;
    display: flex;
    justify-content: center;

    a {
      margin-right: 0.75rem;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  svg {
    color: color('dark');

    &.mail {
      fill: transparent;
      stroke: currentColor;
    }
  }
}
</style>
